import { createActions, createReducer } from 'reduxsauce'

import ConsultaCargosComissaoMPService from '../../servicos/ConsultaRemuneracaoADMRHService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaConsultaCargosComissaoMPInicio: [],
    buscaConsultaCargosComissaoMPErro: ['erro'],
    buscaConsultaCargosComissaoMPSucesso: ['consultaCargosComissaoMP'],
    limpar: [],
    setConsultaCargosComissaoMPEstadoDT: ['estado'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
    dataSincronizacaoDados: null,
    estadoDT: {},
}

// Ação para busca completa
Creators.consultarCargosComissao = filtro => {
    return dispatch => {
        dispatch(Creators.buscaConsultaCargosComissaoMPInicio())
        let serv = new ConsultaCargosComissaoMPService()
        return serv
            .consultarCargosComissao(filtro)
            .then(response => dispatch(Creators.buscaConsultaCargosComissaoMPSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaConsultaCargosComissaoMPErro(error)))
    }
}

const buscaConsultaCargosComissaoMPInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaConsultaCargosComissaoMPErro = (state = INITIAL_STATE, action) => {
    return { ...state, erro: action.erro, carregando: false }
}

const buscaConsultaCargosComissaoMPSucesso = (state = INITIAL_STATE, action) => {
    return {
        ...state,
        lista: action.consultaCargosComissaoMP.resultado,
        dataSincronizacaoDados: action.consultaCargosComissaoMP.dataSincronizacaoDados,
        carregando: false,
    }
}

const limpar = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const setConsultaCargosComissaoMPEstadoDT = (state = INITIAL_STATE, action) => {
    return { ...state, estadoDT: action.estado }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_CONSULTA_CARGOS_COMISSAO_MP_INICIO]: buscaConsultaCargosComissaoMPInicio,
    [Types.BUSCA_CONSULTA_CARGOS_COMISSAO_MP_ERRO]: buscaConsultaCargosComissaoMPErro,
    [Types.BUSCA_CONSULTA_CARGOS_COMISSAO_MP_SUCESSO]: buscaConsultaCargosComissaoMPSucesso,
    [Types.LIMPAR]: limpar,
    [Types.SET_CONSULTA_CARGOS_COMISSAO_MP_ESTADO_DT]: setConsultaCargosComissaoMPEstadoDT,
})
